import { t } from 'util/i18n';

export const sleep = time => new Promise(resolve => setTimeout(() => resolve(), time));

export const range = (start, length) => Array.from(new Array(length), (_, i) => start + i);

export const isExist = value => value !== null && value !== '' && typeof value !== 'undefined';

export const isEmpty = value => !isExist(value);

export const toCamelCase = str => {
	const keyArray = str.split('_');

	return keyArray.reduce((prev, cur) => {
		if (prev === '') {
			return cur;
		}

		if (cur.length > 0) {
			return `${prev}${cur[0].toUpperCase()}${cur.slice(1)}`;
		}

		return prev;
	}, '');
};

export const keyTransform = data => {
	const newData = {};

	Object.keys(data).forEach(key => {
		newData[toCamelCase(key)] = data[key];
	});

	return newData;
};

export const normalizeArray = oldData => {
	const data = {};

	const list = oldData.map(item => {
		data[item.id] = item;
		return item.id;
	});

	return { data, list };
};

// MEN_LIVING: '男生宿舍房',
// WOMEN_LIVING: '女生宿舍房',
// CO_LIVING: '混合宿舍房',
// ROOM: '雅房',
// STUDIO: '獨立套房',
export const mapRoomType = key => t(`roomType:${key}`);

// RENTED: '未開放',
// AVAILABLE: '招募中',
// FULL: '額滿',
export const mapRoomStatus = key => t(`roomStatus:${key}`);

const APARTMENT_DETAIL_MAP = {
	balcony(state) {
		if (state) {
			return { name: 'balcony', value: t('room:yes'), display: true };
		}
		return { name: '', value: '', display: false };
	},
	kitchen(state) {
		if (state) {
			return { name: 'kitchen', value: t('room:yes'), display: true };
		}
		return { name: '', value: '', display: false };
	},
	publicBath(num) {
		if (num > 0) {
			return { name: 'sharedBathrooms', value: `${num}${t('room:room')}`, display: true };
		}
		return { name: '', value: '', display: false };
	},
	pingNumber(num) {
		if (num > 0) {
			return { name: 'size', value: `${num}${t('room:roomSize')}`, display: true };
		}
		return { name: '', value: '', display: false };
	},
	room(num) {
		return { name: 'bedrooms', value: `${num}${t('room:room')}`, display: true };
	},
	floor(num) {
		return { name: 'totalFloors', value: `${num}${t('room:floor')}`, display: true };
	},
	elevator(state) {
		if (state) {
			return { name: 'elevator', value: t('room:yes'), display: true };
		}
		return { name: '', value: '', display: false };
	},
	cleanService(state) {
		return { name: 'cleaningService', value: state, display: true };
	},
	trashService(state) {
		return { name: 'garbageDisposal', value: state, display: true };
	},
};

export const mapApartmentDetail = data =>
	Object.keys(APARTMENT_DETAIL_MAP).map(key => APARTMENT_DETAIL_MAP[key](data[key]));

const MRT_COLOR_MAP = {
	文山內湖: { name: 'BR', color: '#c38830' },
	淡水信義: { name: 'R', color: '#e1012d' },
	松山新店: { name: 'G', color: '#397f56' },
	中和新蘆: { name: 'O', color: '#f5b61c' },
	板橋南港: { name: 'BL', color: '#056dc2' },
	'Wenshan/Neihu': { name: 'BR', color: '#c38830' },
	'Tamsui-Xinyi': { name: 'R', color: '#e1012d' },
	'Songshan-Xindian': { name: 'G', color: '#397f56' },
	'Zhonghe-Xinlu': { name: 'O', color: '#f5b61c' },
	Bannan: { name: 'BL', color: '#056dc2' },
};

export const mapMrtColor = mrtLine =>
	mrtLine.split(',').map(line => ({
		station: `${MRT_COLOR_MAP[line].name} ${line}`,
		lineColor: MRT_COLOR_MAP[line].color,
	}));

export const serverMapEmpty = value => {
	if (typeof value === 'undefined' || value === null) {
		return '';
	}
	return value;
};

// value 回傳 FEMALE / MALE / OTHER
export const mapGenderLabel = value => t(`settings:${value}`);

const USER_LEVEL_MAP = {
	1: 'BLACK_LIST', // 黑名單 L4
	2: 'REGISTERED', // 已註冊 L0
	3: 'DENIED', // 資格未過 L.75
	4: 'UNDER_PREVIEW', // 審核中 L0.5
	5: 'BASIC', // 潛水村民 L1
	6: 'CERTIFIED', // 敲門村民 L2
	7: 'RESIDENT', // 入住室友 L3
};

export const mapUserLevel = id => USER_LEVEL_MAP[id];

const USER_LEVEL_NAME_MAP = {
	1: 'BLOCKED', // 黑名單
	2: 'REGISTERED', // 已註冊
	3: 'MEMBERSHIP_DENIED', // 資格未過
	4: 'MEMBERSHIP_UNDER_REVIEW', // 資格審核中
	5: 'BASIC_MEMBER', // 一般會員
	6: 'CERTIFIED_MEMBER', // 認證會員
	7: 'RESIDENT_MEMBER', // 入住會員
};

export const mapUserLevelName = id => t(`MemberBadge:${USER_LEVEL_NAME_MAP[id]}`);

const BOOKING_TYPE_MAP = {
	REVIEW: '審核中',
	PROCESSING: '合約進行中',
	FINISHED: '已結束',
	CANCEL: '已作廢',
};

export const mapBookingType = key => BOOKING_TYPE_MAP[key];

// PHONE: 'phone',
// LIVE: 'live',
// ONLINE: 'online',
// CHECKIN: 'checkin',
// CHECKOUT: 'checkout',
// INTERVIEW_PHONE: 'interview_phone',
// INTERVIEW_ONLINE: 'interview_online',
export const mapReservationEventType = key => key.toLowerCase();

export const convertReservationEvent = type => type.toUpperCase();

const SOCIAL_TYPE_MAP = {
	FACEBOOK: 'Facebook',
	TWITTER: 'Twitter',
	SPOTIFY: 'Spotify',
	SOUNDCLOUD: 'Soundcloud',
	BEHANCE: 'Behance',
	LINKEDIN: 'Linkedin',
};

export const mapSocialType = type => SOCIAL_TYPE_MAP[type];

export const covertSocialType = type => type.toUpperCase();

export const calculateDigit = num => `${num}`.split('.')[0].length;

export const normalizeRange = (minMax, digit) => {
	const normalizeDigit = 10 ** digit;

	return [
		Math.floor(minMax[0] / normalizeDigit) * normalizeDigit,
		Math.ceil(minMax[1] / normalizeDigit) * normalizeDigit,
	];
};

export const getLocationFromApartment = (cityData, districtData) => {
	let city = '';
	let district = '';

	if (cityData) {
		city = cityData.name;
	}

	if (districtData) {
		district = districtData.name;
	}

	return `${city} ${district}`;
};

export const convertPingToM = value => Math.round(value * 3.30579 * 100) / 100;

export const isiOS = () =>
	!!window.navigator.platform && /iPad|iPhone|iPod/.test(window.navigator.platform);

export const isOutOfMonth = month => {
	if (month.length === 1) {
		return parseInt(month, 10) !== 1 && parseInt(month, 10) !== 0;
	}

	return month.length > 2 || parseInt(month, 10) > 12 || parseInt(month, 10) < 1;
};



// WEBPACK FOOTER //
// ./src/util/helper.js